module.exports = __webpack_public_path__ + "img/food-24.ed389e6b.jpg";